import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function ccra(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@ccra/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccra/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccra/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@ccra/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccra/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccra/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}